module.exports = __webpack_public_path__ + "images/boxes/storyline_3-843e3baa56f72629c47fe336a380dca3.webp";